export default "__VITE_ASSET__BX0nB1P6__"